import { FC } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

type ImageProps = {
  placeholderSrc: string;
  src: string;
  width?: number | string;
  height?: number | string;
  className?: string;
};

export const Image: FC<ImageProps> = ({ placeholderSrc, src, width, height = "h-auto", className }) => {
  return (
    <LazyLoadImage
      width={width}
      height={height}
      className={className}
      effect="blur"
      placeholderSrc={placeholderSrc}
      src={src}
      alt={src}
    />
  );
};
